"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _dataDog["default"];
  }
});
var _dataDog = _interopRequireDefault(require("./dataDog"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }